import { createFileRoute } from "@tanstack/react-router";
import { RequisitionsPage } from "@/features/freelancersmore/RequisitionsPage";

export const Route = createFileRoute("/_app/freelancers/requisitions")({
  component: () => <RequisitionsPage />,
});
